import React from 'react';
import FeetLayout from '../../layouts/FeetLayout';
import FeedContent from './FeedContent';

const Release = () =>
    <FeetLayout>
      <FeedContent />
    </FeetLayout>

export default Release;